import React, { useState } from 'react';
import { IManualItem, IPdf } from 'base/interfaces/product';
import styles from './index.module.less';
import productStyles from '../index.module.less';
import cn from 'classnames';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

type IProps = {
    list?: IPdf[] | IManualItem[];
    type?: 'pdf' | 'onlineManual'; // pdf 和 在线说明书
}

const InstructionalManual: React.FC<IProps> = (props) => {
    const { list, type = 'pdf' } = props
    const [isShow, setIsShow] = useState<boolean>(false)
    const { t } = useTrans();

    const isPdfType = type === 'pdf'

    return (
        <div className={styles['instructional-manual']}>
            <div className={cn(productStyles['right-module'], 'flex')}>
                <p className={productStyles['module-title']}>
                    {t('web_product_instructional_manual_title')}
                </p>

                <div className={productStyles['title-right']} onClick={() => setIsShow(!isShow)}>
                    <Iconfont className={isShow ? 'icon-minus' : 'icon-add'}/>
                </div>
            </div>

            <ul className={cn(
                { [styles.show]: isShow }
            )}>
                {list?.map((pItem: IPdf | IManualItem, pIndex: number) => {
                    return (
                        <li key={pIndex} className={styles.row}>
                            <a href={(pItem as IManualItem)?.webLink || pItem.link} target="_blank" rel="noopener noreferrer">
                                {pItem.name}
                                {isPdfType && (
                                    <Iconfont className={'icon-download'}/>
                                )}
                            </a>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default React.memo(InstructionalManual);
